import request from '@/utils/request'

// 分页查询 AI 配置
export function fetchList (data) {
  return request.post('/system/ai-config/page', data)
}

// 获取活跃配置
export function getActive () {
  return request.get('/system/ai-config/active')
}

// 按模型类型获取配置
export function getByModelType (modelType) {
  return request.get(`/system/ai-config/model/${modelType}`)
}

// 启用指定模型（同时禁用其他模型）
export function enableModel (modelType) {
  return request.post(`/system/ai-config/enable/${modelType}`)
}

// 禁用指定模型
export function disableModel (modelType) {
  return request.post(`/system/ai-config/disable/${modelType}`)
}

// 创建配置
export function create (data) {
  return request.post('/system/ai-config/create', data)
}

// 更新配置
export function updateById (data) {
  return request.post('/system/ai-config/update', data)
}

// 删除配置
export function deleteById (id) {
  return request.delete(`/system/ai-config/${id}`)
}

// 切换指定模型的智能回复开关
export function toggleSmartReply (modelType) {
  return request.post(`/system/ai-config/toggle-smart-reply/${modelType}`)
}
